const defaultState = {
  roundCount: 1,
  roundWinUser: 0,
  roundWinComputer: 0,
  roundOne: 3,
  roundTwo: 0,
  roundThree: 0,
  roundFour: 0,
  roundFive: 0,
  roundSix: 0,
  roundSeven: 0,
  currentSimbolUser: 1,
  currentSimbolComputer: 2,
};

const NEXT_ROUND = 'NEXT_ROUND';
const SET_ROUND_WIN_COMPUTER = 'SET_ROUND_WIN_COMPUTER';
const ZEROING_STATE_ROUND = 'ZEROING_STATE_ROUND';
const SET_ROUND_ONE = 'SET_ROUND_ONE';
const SET_ROUND_TWO = 'SET_ROUND_TWO';
const SET_ROUND_THREE = 'SET_ROUND_THREE';
const SET_ROUND_FOUR = 'SET_ROUND_FOUR';
const SET_ROUND_FIVE = 'SET_ROUND_FIVE';
const SET_ROUND_SIX = 'SET_ROUND_SIX';
const SET_ROUND_SEVEN = 'SET_ROUND_SEVEN';
const SET_ROUND_WIN_USER = 'SET_ROUND_WIN_USER';
const SET_CURRENT_SIMBOL_USER = 'SET_CURRENT_SIMBOL_USER';
const SET_CURRENT_SIMBOL_COMPUTER = 'SET_CURRENT_SIMBOL_COMPUTER';

export const roundReducer = (state = defaultState, action) => {
  switch (action.type) {
    case NEXT_ROUND:
      return { ...state, roundCount: state.roundCount + action.payload };
    case SET_ROUND_WIN_USER:
      return { ...state, roundWinUser: state.roundWinUser + action.payload };
    case SET_ROUND_WIN_COMPUTER:
      return {
        ...state,
        roundWinComputer: state.roundWinComputer + action.payload,
      };
    case SET_ROUND_ONE:
      return { ...state, roundOne: (state.roundOne = action.payload) };
    case SET_ROUND_TWO:
      return { ...state, roundTwo: (state.roundTwo = action.payload) };
    case SET_ROUND_THREE:
      return { ...state, roundThree: (state.roundThree = action.payload) };
    case SET_ROUND_FOUR:
      return { ...state, roundFour: (state.roundFour = action.payload) };
    case SET_ROUND_FIVE:
      return { ...state, roundFive: (state.roundFive = action.payload) };
    case SET_ROUND_SIX:
      return { ...state, roundSix: (state.roundSix = action.payload) };
    case SET_ROUND_SEVEN:
      return { ...state, roundSeven: (state.roundSeven = action.payload) };
    case SET_CURRENT_SIMBOL_USER:
      return {
        ...state,
        currentSimbolUser: (state.currentSimbolUser = action.payload),
      };
    case SET_CURRENT_SIMBOL_COMPUTER:
      return {
        ...state,
        currentSimbolComputer: (state.currentSimbolComputer = action.payload),
      };

    case ZEROING_STATE_ROUND:
      return {
        ...state,
        roundCount: (state.roundCount = action.payload),
        roundWinUser: (state.roundWinUser = action.payload),
        roundWinComputer: (state.roundWinComputer = action.payload),
        roundOne: (state.roundOne = action.payload + 3),
        roundTwo: (state.roundTwo = action.payload),
        roundThree: (state.roundThree = action.payload),
        roundFour: (state.roundFour = action.payload),
        roundFive: (state.roundFive = action.payload),
        roundSix: (state.roundSix = action.payload),
        roundSeven: (state.roundSeven = action.payload),
      };

    default:
      return state;
  }
};

// export const nextRoundAction = (payload) => ({
//   type: NEXT_ROUND,
//   payload,
// });
// export const setRoundOneAction = (payload) => ({
//   type: SET_ROUND_ONE,
//   payload,
// });
// export const setRoundTwoAction = (payload) => ({
//   type: SET_ROUND_TWO,
//   payload,
// });
// export const setRoundThreeAction = (payload) => ({
//   type: SET_ROUND_THREE,
//   payload,
// });
// export const setRoundFourAction = (payload) => ({
//   type: SET_ROUND_FOUR,
//   payload,
// });
// export const setRoundFiveAction = (payload) => ({
//   type: SET_ROUND_FIVE,
//   payload,
// });
// export const setRoundSixAction = (payload) => ({
//   type: SET_ROUND_SIX,
//   payload,
// });
// export const setRoundSevenAction = (payload) => ({
//   type: SET_ROUND_SEVEN,
//   payload,
// });
// export const zeroingStateRoundAction = (payload) => ({
//   type: ZEROING_STATE_ROUND,
//   payload,
// });
